const endpoint = "https://eb5b.cuba-go.com"
const cpoint = "https://central-backend.cuba-go.com"

const mediapoint = `${cpoint}/electronic`
const startpoint = `${cpoint}/eb5/`

export { endpoint, mediapoint, startpoint }
